import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link, NavLink, useLocation } from "react-router-dom";

import "../Styles/GoogleTranslate.css";

const logo = "/cos - 2026 3.png";

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const nav_links = [
    // Quantumtech
    { name: "Home", link: "/" },
    { name: "About", link: "/about-Quantumtech-conclave" },
    { name: "Executive Panel", link: "/executive-panel-members/" },
    { name: "Tracks", link: "/Quantumtech-conference-tracks/" },
    { name: "Orators", link: "/Quantumtech-orators" },
    { name: "Schedule", link: "/Quantumtech-event-schedule" },
    { name: "Venue", link: "/venue" },
    { name: "Event Partners", link: "/event_partners" },
    { name: "Contact", link: "/contact" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      requestAnimationFrame(() => {
        setScrolled(window.scrollY > 80);
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="bg-white sticky top-0 z-50 w-full shadow-sm">
      <div className="flex items-center justify-between px-2 py-2 md:py-2 transition-all duration-300">
        <div
          className={`transition-all duration-300 ${scrolled ? "h-20" : "h-20"
            }`}
        >
          <img
            src={logo}
            alt="QUANTUMTECH Logo"
            className="rounded-full object-cover transition-all duration-300"
            loading="lazy"
            style={{
              height:
                isOpen && window.innerWidth < 1024
                  ? "5rem"
                  : scrolled
                    ? "5rem"
                    : "8rem",
              width:
                isOpen && window.innerWidth < 1024
                  ? "6rem"
                  : scrolled
                    ? "6rem"
                    : "8rem",
              marginTop:
                isOpen && window.innerWidth < 1024
                  ? "0.5rem"
                  : scrolled
                    ? "0rem"
                    : "1rem",

              // 🔥 Add black circular background
              backgroundColor: "black",
            }}
          />
        </div>

        {/* Desktop Navigation */}
        <nav
          className={`hidden lg:flex justify-between items-center text-md font-bold-100 ${scrolled ? "gap-8 ml-20" : "gap-6 ml-16"
            }`}
        >
          {nav_links.map((item, index) => (
            <NavLink
              key={index}
              to={item.link}
              end={item.link === "/"}
              className={({ isActive }) =>
                `hover-underline-animation text-black hover:text-[#6D6D6D] transition ${isActive
                  ? "border-[#6D6D6D] border-b-2"
                  : "border-transparent"
                }`
              }
              style={{
                marginRight: scrolled ? "0px" : "4px",
              }}
            >
              {item.name}
            </NavLink>
          ))}
        </nav>

        {/* Action Buttons */}
        <div className="hidden lg:flex items-center gap-5">
          <div className="flex items-center gap-1">
            <Link
              to="https://helixconferences.com/buy-a-ticket"
              className="py-2 px-8 text-white rounded-full bg-[#6D6D6D] transition hover:bg-black"
              target="blank"
            >
              Register
            </Link>
            <div className="flex flex-col items-start justify-center">
              <div
                id="google_translate_element"
                className="font-sm text-[#6D6D6D]"
              ></div>
            </div>
          </div>
        </div>

    <div className="lg:hidden ml-[190px] z-50">
  <button
    aria-label="Toggle menu"
    onClick={() => setIsOpen(!isOpen)}
    className="p-2 text-black hover:text-gray-700 focus:outline-none"
  >
    {isOpen ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
  </button>
</div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="lg:hidden bg-[#6D6D6D] px-4 pb-4 space-y-4 shadow-md text-right">
          {nav_links.map((item, index) => (
            <NavLink
              key={index}
              to={item.link}
              end={item.link === "/"}
              className={({ isActive }) =>
                `block text-sm transition ${isActive ? "text-black font-bold" : "text-white hover:text-black"
                }`
              }
              onClick={() => setIsOpen(false)}
            >
              {item.name}
            </NavLink>
          ))}
          <div className="flex flex-col items-end gap-2">
            <div id="google_translate_element_mobile_2" className="mt-2 text-right"></div>
            <Link
              to="https://helixconferences.com/buy-a-ticket"
              target="_blank"
              className="block w-full border border-white text-center py-2 rounded-full text-white hover:bg-white hover:text-[#6D6D6D] transition"
              onClick={() => setIsOpen(false)}
            >
              Register
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
